/**
 * Dialog for confirming question deletion
 */

import React from 'react';
import './QuestionDialogs.css';

interface DeleteQuestionDialogProps {
    isOpen: boolean;
    onClose: () => void;
    questionId: number;
    questionText: string;
}

export default function DeleteQuestionDialog({
    isOpen,
    onClose,
    questionId,
    questionText,
}: DeleteQuestionDialogProps) {
    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        try {
            const response = await fetch(`/api/questions/${questionId}`, {
                method: 'DELETE',
            });

            if (response.ok) {
                onClose();
            }
        } catch (error) {
            console.error('Failed to delete question:', error);
        }
    };

    const handleOverlayClick = (e: React.MouseEvent) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    if (!isOpen) return null;

    return (
        <div className="overlay" onClick={handleOverlayClick}>
            <div className="dialog">
                <div className="header">
                    <h2 className="title">Delete Question</h2>
                    <button className="closeButton" onClick={onClose} type="button">
                        ×
                    </button>
                </div>
                <form onSubmit={handleSubmit} className="form">
                    <p style={{ marginBottom: '1.5rem', color: 'var(--text-color-primary)' }}>
                        Are you sure you want to delete this question?
                    </p>
                    <div
                        style={{
                            backgroundColor: 'var(--background-secondary-color)',
                            padding: '1rem',
                            borderRadius: '0.5rem',
                            marginBottom: '1.5rem',
                            border: '1px solid var(--border-color)',
                        }}
                    >
                        <strong style={{ color: 'var(--text-color-primary)' }}>{questionText}</strong>
                    </div>
                    <p style={{ color: 'var(--text-color-secondary)', fontSize: '0.9rem' }}>
                        This action cannot be undone.
                    </p>
                    <div className="buttonGroup">
                        <button type="button" className="cancelButton" onClick={onClose}>
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="submitButton"
                            style={{ backgroundColor: '#dc3545', borderColor: '#dc3545' }}
                        >
                            Delete Question
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}
